import React, {Component} from 'react';
import ReactNotification from 'react-notifications-component';

import Cabecera from './Cabecera';
import Pie from './Pie';

import 'react-notifications-component/dist/theme.css';

class LayoutSC extends Component {

  constructor(props) {
    super(props);
    this.state = {
      main: false,
    };
  }
  setStateGlobal = (state) => {
    window.location.reload(false);
  }

  render() {
    return (
      <div className='expandFullPage'>
        <ReactNotification />
        <div className='body'>
          <Cabecera parentState={this.state} setParentStateSteps={this.setStateGlobal}/> {this.props.children}
        </div>
        <Pie tieneFlecha = "true" />
      </div>
    );
  }
}

export default LayoutSC;
